// Shared constants and small components for the admin panel modules.
import { ALLERGENS } from "@/lib/allergens";

// Compact allergen chip selector reused for products, option choices and add-ons.
export function AllergenPicker({ value, onChange, size = "sm" }) {
  const sel = value || [];
  return (
    <div className="flex flex-wrap gap-1">
      {ALLERGENS.map((a) => {
        const on = sel.includes(a.key);
        return (
          <button
            type="button"
            key={a.key}
            title={a.sv}
            onClick={() => onChange(on ? sel.filter((k) => k !== a.key) : [...sel, a.key])}
            className={`${size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-1"} rounded border transition-all ${
              on ? "bg-[#D4B483]/15 border-[#D4B483]/50 text-[#D4B483]" : "bg-[#0A0A0A] border-[#27272A] text-[#A8ABB2] hover:text-[#D4D4D8]"
            }`}
          >
            {a.emoji} {a.sv}
          </button>
        );
      })}
    </div>
  );
}
import {
  LogOut, Clock, Check, X, ChefHat, Package, CheckCircle, Plus, Trash2,
  Loader2, Users, Shield, UserCog, MessageSquare, BarChart3, Settings,
  Volume2, VolumeX, TrendingUp, DollarSign, ShoppingBag, Store, MapPin,
  Phone, Calendar, Ban, Star, Pencil, ImageIcon, Upload, ChevronLeft, ChevronRight, CalendarDays,
  Key, Sparkles, UtensilsCrossed, Menu, ChevronUp, ChevronDown, Database, Download,
  History, RotateCcw, Save, ClipboardCheck
} from "lucide-react";

export const STATUS_LABELS = {
  waiting_for_confirmation: "Ny", accepted: "Accepterad", rejected: "Avvisad",
  paid: "Accepterad", preparing: "Tillagas", ready: "Klar", completed: "Slutförd", cancelled: "Avbruten"
};
export const STATUS_COLORS = {
  waiting_for_confirmation: "bg-[#F59E0B]/15 text-[#F59E0B]", accepted: "bg-[#3B82F6]/15 text-[#3B82F6]",
  rejected: "bg-[#EF4444]/15 text-[#EF4444]", paid: "bg-[#3B82F6]/15 text-[#3B82F6]",
  preparing: "bg-[#A855F7]/15 text-[#A855F7]", ready: "bg-[#22C55E]/15 text-[#22C55E]",
  completed: "bg-[#6B7280]/15 text-[#A8ACB4]", cancelled: "bg-[#EF4444]/15 text-[#EF4444]"
};
export const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
export const DAY_LABELS = { monday: "Måndag", tuesday: "Tisdag", wednesday: "Onsdag", thursday: "Torsdag", friday: "Fredag", saturday: "Lördag", sunday: "Söndag" };
// Canonical stock units: styck, gram, kilogram.
export const UNIT_OPTIONS = [
  { value: "st", label: "st (styck)" },
  { value: "g", label: "g (gram)" },
  { value: "kg", label: "kg (kilogram)" },
];
export const UNIT_ALIASES = { st: "st", styck: "st", stycken: "st", pcs: "st", stk: "st", g: "g", gram: "g", gr: "g", kg: "kg", kilo: "kg", kilogram: "kg", annat: "st" };
export const normUnit = (u) => UNIT_ALIASES[String(u || "").trim().toLowerCase()] || "st";
export const TIME_RANGES = [
  { label: "10-20 min", value: "10-20" },
  { label: "20-30 min", value: "20-30" },
  { label: "30-40 min", value: "30-40" },
  { label: "40-50 min", value: "40-50" },
  { label: "50-60 min", value: "50-60" },
  { label: "60+ min",   value: "60+" },
];

export const MAPS_ORIGIN_ADDRESS = "östra storgatan 2 olofström";

// Notification sound hook

// VAT categories by transaction type (mirrors backend/vat.py TAX_CATEGORIES).
// Rates come from the rules registry — labels stay rate-free on purpose.
export const TAX_CATEGORIES = [
  ["catering_service", "Catering med servering"],
  ["food_takeaway", "Mat – avhämtning/leverans"],
  ["restaurant_service", "Servering på plats"],
  ["alcohol", "Alkohol"],
  ["other_standard", "Övrigt (standardmoms)"],
];
